import React from 'react';
import PhotoUploadErrorBoundary from './PhotoUploadErrorBoundary';
import PhotoUploadChat from './PhotoUploadChat';

interface PhotoUploadChatWrapperProps {
  onPhotosSelected: (data: { photos: File[] }) => void;
}

const PhotoUploadChatWrapper = ({ onPhotosSelected }: PhotoUploadChatWrapperProps) => {
  const handleErrorFallback = () => {
    console.log('📸 PhotoUploadChatWrapper - Error fallback triggered');
    onPhotosSelected({ photos: [] });
  };

  return (
    <PhotoUploadErrorBoundary onErrorFallback={handleErrorFallback}>
      <PhotoUploadChat onPhotosSelected={onPhotosSelected} />
    </PhotoUploadErrorBoundary>
  );
};

export default PhotoUploadChatWrapper;